// extracted by mini-css-extract-plugin
export default {"button-with-icon":"IconButton_button-with-icon__1PCOk","disabled-button":"IconButton_disabled-button__fIkAg"};